import styled from 'styled-components'

export const Container = styled.div`
    position: relative;
    top: unset;
    left: unset;
    transform: none;
    background-color: #fff;
    border-radius: 1vw;
    z-index: 9004;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
    min-width: 360px;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 31vw;
    margin-top: 2.8vh;
    margin-left: 1.2vw;
    margin-right: 0.7vw;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const OptionTabDiv = styled.div`
    display: flex;
    width: 30.4vw;
    margin-top: 2.5vh;
    margin-left: 1.2vw;
    border: 1px #EBEBEB solid;
    border-radius: 1vw;
    cursor:pointer;

    &:hover {
        background-color: #f7f7f7;
    }
`

export const OptionImg = styled.img`
    width: 1.6vw;
    margin-left: 1.2vw;
`

export const OptionTextDiv = styled.div`
    margin-left: 1.2vw;
`

export const OptionMainText = styled.h3`
    font-family: 'Inter', sans-serif;
    font-size: 1.2vw;
    margin-top: 3vh;
    margin-bottom: 0;
`

export const OptionSubText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    margin-top: 0.6vh;
    margin-bottom: 3vh;
`

export const ArrowImg = styled.img`
    margin-left: 6.8vw;
    cursor: pointer;
    width: 2vw;
`

export const CancelButton = styled.button`
    width: 8vw;
    height: 5.8vh;
    background-color: #fff;
    color: #0090D3;
    font-family: 'Inter', sans-serif;
    font-size: 1.1vw;
    font-weight: 700;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 23.5vw;
    border: 1px #0090D3 solid;
    border-radius: 3vw;
    cursor: pointer;
`